export const EVENT_NAMES = {
  SEND_MESSAGE: 'send_message'
}
